import { ButtonHTMLAttributes } from 'react';
import tw from 'twin.macro';
import { CSSProp } from 'styled-components';

import { Button } from '@components/Button';

const StyledButton = tw(
  Button
)`flex items-center justify-between text-xs border border-solid border-gray-1 rounded-md py-[4px] px-[11px] transition-all duration-100`;
const HoverOpacityWrapper = tw.div`hover:opacity-75`;

export const FilterButton = ({
  children,
  css,
  isLoading,
  disabled,
  ...props
}: {
  children: React.ReactNode;
  css?: CSSProp;
  isLoading?: boolean;
  disabled?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <HoverOpacityWrapper>
      <StyledButton css={css} isLoading={isLoading} disabled={disabled} {...props}>
        {children}
      </StyledButton>
    </HoverOpacityWrapper>
  );
};
